import { Collapse, Ellipsis, Grid, Modal, Space, Swiper, SwiperRef } from 'antd-mobile';
import { QuestionCircleOutline } from 'antd-mobile-icons';
import { GlobalLoadingContext } from 'App';
import img from 'app/img';
import LevelInfo from 'components/dot/level-info/index';
import { useI18n } from 'i18n/useI18n';
import { useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { UserGroupDataType } from 'services/apis/usr/user-group-api';
import PayModal from './PayModal';

export type UserCenterDT = {
  userPolyInfo: UserPolyInfoDT;
  userGroupList: UserGroupDataType[];
  userPageIndex: number;
  setUserPageIndex: any;
};

export type QuestType = {
  k: string;
  q: string;
  a: string;
};

export const Label = (img: string, tip: string) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'align',
        margin: 5,
      }}
    >
      <img
        src={img}
        width={120}
        height={40}
      />
      {/* <span style={{ marginLeft: 10, marginTop: 3 }}>{tip}</span> */}
    </div>
  );
};

export const options = [
  // {
  //   label: Label("assets/img/icon-bitcoin.ico", "Coinbase"),
  //   value: "coinbase",
  //   description: "2% off",
  // },
  // {
  //   label: Label("assets/img/icon-stripe.png", "Stripe"),
  //   value: "stripe",
  //   disabled: true,
  //   description: "suspension",
  // },
  {
    label: Label(img.alipay_logo, '支付宝'),
    value: 'alipay',
    disabled: false,
    description: <div className=" text-slate-600">* 免通道费</div>,
  },
  {
    label: Label(img.wechatpay_logo, '微信支付'),
    value: 'wxpay',
    disabled: false,
    description: <div className=" text-slate-600">* 免通道费</div>,
  },
];

const UserCenter = (props: UserCenterDT) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [modalBtnBgcolor, setModalBtnBgcolor] = useState<string>('');
  const showGlobalLoading = useContext(GlobalLoadingContext).showGlobalLoading;

  const [, _refreshView] = useState('');
  const payMode = useRef<string>();
  const waitTimeRef = useRef<number>(10);
  const [waitTime, setWaitTime] = useState<string>(waitTimeRef.current + t('level-info.index.180777-0'));
  const [payIframeVisible, setPayIframeVisible] = useState(false);
  const [payIframeUrl, setPayIframeUrl] = useState('');

  const [tabIndex, setTabIndex] = useState(0);
  const swiperRef = useRef<SwiperRef>(null);
  const [showTipModal, setShowTipModal] = useState<boolean>(false);
  const [confirmModalVisiable, setConfirmModalVisiable] = useState<boolean>(false);

  const questionList: QuestType[] = [
    {
      k: 'q1',
      q: t('center.index.399952-0'),
      a: t('center.index.399952-1'),
    },
    {
      k: 'q2',
      q: t('center.index.399952-2'),
      a: t('center.index.399952-3'),
    },
    {
      k: 'q3',
      q: t('center.index.399952-4'),
      a: t('center.index.399952-5'),
    },
    {
      k: 'q4',
      q: t('center.index.399952-6'),
      a: t('center.index.399952-7'),
    },
  ];

  const questionItemList = () => {
    return questionList.map((item) => {
      return (
        <Space
          justify="start"
          align="center"
          key={item.k}
          onClick={() => {
            setQAClickKey(item.k);
            handleQAOpen(true);
          }}
          style={{ margin: 0 }}
        >
          <QuestionCircleOutline fontSize={16} />
          <Ellipsis
            direction="start"
            content={item.q}
            rows={2}
            style={{ width: 350, textAlign: 'left' }}
          />
        </Space>
      );
    });
  };

  const questionItemList2 = () => {
    return questionList.map((item) => {
      return (
        <Collapse.Panel
          key={item.k}
          title={item.q}
        >
          {item.a}
        </Collapse.Panel>
      );
    });
  };

  const [QAOpen, handleQAOpen] = useState(false);

  const [QAClickKey, setQAClickKey] = useState('');

  const [selectUsergroup, setSelectUsergroup] = useState<UserGroupDataType>(null);
  const LevelList = (data: { userGroupList: UserGroupDataType[] }) => {
    return (
      <>
        {data.userGroupList
          .sort((a, b) => a.groupLevel - b.groupLevel)
          .map((item, index) => {
            return (
              <LevelInfo
                key={index}
                userGroup={item}
                selectUsergroup={(usergroup) => {
                  console.log(usergroup);
                  setSelectUsergroup(usergroup);
                  setConfirmModalVisiable(true);
                }}
              />
            );
          })}
      </>
    );
  };

  const usergroupTypeList: [string, UserGroupDataType[]][] = Object.entries(
    props.userGroupList
      .sort((a, b) => a.groupLevel - b.groupLevel)
      .reduce((acc, item) => {
        // 如果分组中没有该类型，先初始化为数组
        if (!acc[item.groupType]) {
          acc[item.groupType] = [];
        }
        // 将当前元素推入对应的类型数组中
        acc[item.groupType].push(item);
        return acc;
      }, {})
  );

  // 页面内容
  return (
    <>
      {/* 会员组详情 */}
      <div
        style={{
          background: `url(${img.loginCredentialsBg}) center center / cover no-repeat`,
        }}
        className=" rounded-md shadow-md mt-2 py-2"
      >
        <div className="pt-4 flex items-center justify-center">
          <div className=" bg-slate-100 bg-opacity-95 px-2 py-4 pb-8 rounded-md shadow-md text-base text-center">
            {usergroupTypeList.map(([type, items], index) => (
              <span
                key={type[0]}
                className={[
                  ' m-2',
                  type === usergroupTypeList[tabIndex][0] ? 'text-orange-500' : 'text-slate-500 ',
                ].join(' ')}
                onChange={() => {
                  swiperRef.current?.swipeTo(index);
                }}
                onClick={() => {
                  setTabIndex(index);
                  swiperRef.current?.swipeTo(index);
                }}
              >
                {type}
              </span>
            ))}
          </div>
        </div>
        <Swiper
          ref={swiperRef}
          slideSize={94}
          trackOffset={0}
          stuckAtBoundary={false}
          className=" -mt-7 -pb-6 rounded-md"
          defaultIndex={0}
          tabIndex={tabIndex}
          indicator={(total, current) => null}
          onIndexChange={(index) => {
            setTabIndex(index);
            window.scrollTo({ top: 300, behavior: 'smooth' });
          }}
        >
          {usergroupTypeList.map(([type, items]) => (
            <Swiper.Item
              key={type[0]}
              className=" pl-3"
            >
              <LevelList userGroupList={items as UserGroupDataType[]} />
              <div className=" m-4 p-3 bg-slate-200/50 shadow-md rounded-md">
                <div className=" text-white text-base mt-2 mb-4 text-center">
                  <span>解锁分区</span>
                  <span className=" rounded-md shadow-md p-1 ml-2 bg-black/50">{items[0].groupZone.areaName}</span>
                </div>
                <div>
                  <Grid
                    columns={3}
                    gap={8}
                  >
                    {items[0].groupZone.areaList.map((area) => (
                      <Grid.Item
                        key={area}
                        className=" flex justify-center items-center py-3 shadow-md rounded-md bg-gradient-to-br from-white/80 to-white/20 bg-white/50 text-orange-500 text-sm text-nowrap"
                      >
                        {area}
                      </Grid.Item>
                    ))}
                  </Grid>
                  <div className=" mt-2 flex justify-center items-center p-4 shadow-md rounded-md bg-gradient-to-br from-white/80 to-white/20 bg-white/50 text-orange-500/70 text-sm">
                    更多内容待君探索
                  </div>
                </div>
              </div>
            </Swiper.Item>
          ))}
        </Swiper>
      </div>

      {/* 支付弹窗 */}
      {selectUsergroup && (
        <>
          <PayModal
            selectUsergroup={selectUsergroup}
            userId={props.userPolyInfo?.asUser.uuid}
            closePayModel={() => {
              setConfirmModalVisiable(false);
              setSelectUsergroup(null);
            }}
          />
        </>
      )}

      {/* 购买必读 */}
      <div
        style={{
          textAlign: 'left',
          lineHeight: 1.6,
          margin: '30px 0px',
        }}
      >
        <span style={{ fontSize: 14 }}>{t('center.index.399952-8')} </span>
        <br />
        <span style={{ fontSize: 12, color: '#666' }}>{t('center.index.399952-7')}</span>
      </div>

      {/* 常见答疑 */}
      <div>
        <div>
          <Modal
            closeOnAction
            closeOnMaskClick
            destroyOnClose={false}
            // open={QAOpen}
            visible={QAOpen}
            // onCancel={() => {
            //   handleQAOpen(false);
            // }}
            onClose={() => {
              handleQAOpen(false);
            }}
            // onOk={() => {
            //   handleQAOpen(false);
            // }}
            onAction={() => {
              handleQAOpen(false);
            }}
            // footer={[<a href="/user">{t("center.index.399952-9")}</a>]}
            content={
              <Collapse
                accordion={true}
                activeKey={QAClickKey}
                onChange={(activeKey) => {
                  if (activeKey != null) {
                    setQAClickKey(activeKey);
                  }
                }}
              >
                {questionItemList2()}
              </Collapse>
            }
          />
        </div>
        <div className=" text-sm">
          <div className=" my-2">{t('center.index.399952-10')}</div>
          <Grid
            columns={1}
            style={{ '--gap-vertical': '8px' }}
          >
            {questionItemList()}
          </Grid>
        </div>
      </div>
    </>
  );
};
export default UserCenter;
